
export class MultiUnarchivePasswordEntry {
    id: number;
    recoveryId: string;
    encryptedPasswordKey: string;
}